import { GutBodyConnectionsBody } from '@repo/ui';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useGutBodyProps from 'hooks/useGutBodyProps';
import { useMobileDetection } from 'hooks/useMobileDetection';
import useSelectOrgan from 'hooks/useSelectOrgan';
import useOrgans from 'services/organs/useOrgans';
import styles from './BodyContainer.module.css';

export default function BodyContainer() {
  const { currentKit } = useCurrentKitAndTinyAccount();
  const selectOrgan = useSelectOrgan('home_card');
  const { isMobile } = useMobileDetection();

  const { organs } = useOrgans(currentKit?.id);
  const { age, pregnant, sex, colorVariant } = useGutBodyProps();

  return (
    <div className={styles.container}>
      <GutBodyConnectionsBody
        age={age}
        pregnant={pregnant}
        organs={organs}
        sex={sex}
        onOrganSelect={selectOrgan}
        showDotAndTooltips={!isMobile}
        fadeBody
        colorVariant={colorVariant}
      />
    </div>
  );
}
